export default __webpack_public_path__ + "static/media/keyboard.33695765.jpg";